var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#chevron-left';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-chevron-left';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?chevron-left#chevron-left';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?chevron-left#view-chevron-left';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 5 8',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };